import React, { useEffect, useState } from "react";
import { CardBody, Col, Form, FormGroup, Label, Row } from "reactstrap";
import { translate } from "react-switch-lang";
import ButtonComponent from "../../button-componenet/buttonComponent";
import { useForm } from "react-hook-form";
import Dropzone from "react-dropzone-uploader";
import styles from "./addSetting.module.scss";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import { ThematicDto } from "../../../models/thematicDto";
import { toast } from "react-toastify";
import { TypeSetting } from "../../../models/typeSetting";
import { FileStatus } from "../../../models/fileStatus";
import { IMAGE_EXTENTION } from "../../../Data/extentionImage";
import { DropZoneEventDto } from "../../../models/dropZoneEventDto";
import { DocumentTypeDto } from "../../../models/documentTypeDto";
import { CountryDto } from "../../../models/countryDto";
import { VideoTypeDto } from "../../../models/videoTypeDto";

const AddSetting: React.FC<{ t: (key: string) => {}; settingModal: any; toggle: (data: any) => void; handleGet: () => void; type: TypeSetting }> = props => {
  toast.configure();
  const path = "/Mediatheque/image/Setting/";
  const httpClient = useHttpClient(true);
  const [isShowDropZone, setIsShowDropZone] = useState(true);
  const [selectedSupport, setSelectedSupport] = useState<any>(null);
  const [urlImage, setUrlImage] = useState("");
  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      titleFrancais: props?.settingModal?.titleFrancais ? props.settingModal.titleFrancais : "",
      titleAnglais: props.settingModal?.titleAnglais ? props.settingModal.titleAnglais : "",
    },
  });

  const handleChangeStatus = ({ meta, file }: DropZoneEventDto, status: string) => {
    if (status === FileStatus.REMOVED) {
      setSelectedSupport(null);
    } else {
      if (IMAGE_EXTENTION.includes(file.name.slice(file.name.lastIndexOf(".") + 1, file.name.length).toLowerCase())) {
        if (status === FileStatus.DONE) {
          setSelectedSupport(file);
          setUrlImage(meta.previewUrl);
        }
      } else {
        toast.error(String(props.t("message_extention_not_allowed")));
      }
    }
  };

  useEffect(() => {
    if (props.settingModal?.urlImage) {
      setIsShowDropZone(false);
    } else {
      setIsShowDropZone(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleThematic = (data: ThematicDto) => {
    if (!props.settingModal?.urlImage) {
      const formData = new FormData();
      formData.append("file", selectedSupport);
      httpClient.current
        ?.post(`/thematic/files?path=${path}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          data.pathImage = response.data;
          httpClient.current?.post("/thematic", data).then(response => {
            toast.success(props.t("thematic.message_toastr_add_thematic"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            props.toggle(null);
            props.handleGet();
          });
        });
    } else {
      updateThematic(data);
    }
  };

  const handleDocument = (data: DocumentTypeDto) => {
    if (!props.settingModal?.urlImage) {
      const formData = new FormData();
      formData.append("file", selectedSupport);
      httpClient.current
        ?.post(`/document/files?path=${path}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          data.pathImage = response.data;
          httpClient.current?.post("/document", data).then(response => {
            toast.success(props.t("document_type.message_toastr_add_type_document"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            props.toggle(null);
            props.handleGet();
          });
        });
    } else {
      updateDocument(data);
    }
  };

  const updateDocument = (data: DocumentTypeDto) => {
    if (selectedSupport) {
      const formData = new FormData();
      formData.append("file", selectedSupport);
      httpClient.current
        ?.post(`/document/files?path=${path}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          data.pathImage = response.data;
          data.documentTypeId = props.settingModal.documentTypeId;
          httpClient.current?.put("/document", data).then(response => {
            toast.success(props.t("message_toastr_update"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            props.toggle(null);
            props.handleGet();
          });
        });
    } else {
      data.documentTypeId = props.settingModal.documentTypeId;
      data.pathImage = props.settingModal.pathImage;
      data.urlImage = props.settingModal.urlImage;
      if (data.titleFrancais !== props.settingModal.titleFrancais || data.titleAnglais !== props.settingModal.titleAnglais) {
        httpClient.current?.put("/document", data).then(response => {
          toast.success(props.t("message_toastr_update"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
          props.toggle(null);
          props.handleGet();
        });
      } else {
        props.toggle(null);
      }
    }
  };

  const onSubmit = (data: CountryDto) => {
    if (props.type === TypeSetting.THEMATIC) {
      handleThematic(data);
    } else if (props.type === TypeSetting.DOCUMENT) {
      handleDocument(data);
    } else if (props.type === TypeSetting.VIDEO) {
      handleVideoType(data);
    } else {
      handleCountry(data);
    }
  };

  const handleCountry = (data: CountryDto) => {
    if (!props.settingModal?.urlImage) {
      const formData = new FormData();
      formData.append("file", selectedSupport);
      httpClient.current
        ?.post(`/country/files?path=${path}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          data.pathImage = response.data;
          httpClient.current?.post("/country", data).then(response => {
            props.toggle(null);
            toast.success(props.t("country.message_toastr_add_country"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            props.handleGet();
          });
        });
    } else {
      updateCountry(data);
    }
  };

  const updateCountry = (data: CountryDto) => {
    if (selectedSupport) {
      const formData = new FormData();
      formData.append("file", selectedSupport);
      httpClient.current
        ?.post(`/country/files?path=${path}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          data.pathImage = response.data;
          data.countryId = props.settingModal.countryId;
          httpClient.current?.put("/country", data).then(response => {
            props.toggle(null);
            props.handleGet();
            toast.success(props.t("message_toastr_update"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
          });
        });
    } else {
      data.countryId = props.settingModal.countryId;
      data.pathImage = props.settingModal.pathImage;
      data.urlImage = props.settingModal.urlImage;
      if (data.titleFrancais !== props.settingModal.titleFrancais || data.titleAnglais !== props.settingModal.titleAnglais) {
        httpClient.current?.put("/country", data).then(response => {
          props.toggle(null);
          props.handleGet();
          toast.success(props.t("message_toastr_update"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
        });
      } else {
        props.toggle(null);
      }
    }
  };

  const handleVideoType = (data: VideoTypeDto) => {
    if (!props.settingModal?.urlImage) {
      const formData = new FormData();
      formData.append("file", selectedSupport);
      httpClient.current
        ?.post(`/video_type/files?path=${path}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          data.pathImage = response.data;
          httpClient.current?.post("/video_type", data).then(response => {
            props.toggle(null);
            toast.success(props.t("video_type.message_toastr_add_video_type"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            props.handleGet();
          });
        });
    } else {
      updateVideoType(data);
    }
  };

  const updateVideoType = (data: VideoTypeDto) => {
    if (selectedSupport) {
      const formData = new FormData();
      formData.append("file", selectedSupport);
      httpClient.current
        ?.post(`/video_type/files?path=${path}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          data.pathImage = response.data;
          data.videoTypeId = props.settingModal.videoTypeId;
          httpClient.current?.put("/video_type", data).then(response => {
            props.toggle(null);
            toast.success(props.t("message_toastr_update"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            props.handleGet();
          });
        });
    } else {
      data.videoTypeId = props.settingModal.videoTypeId;
      data.pathImage = props.settingModal.pathImage;
      data.urlImage = props.settingModal.urlImage;
      if (data.titleFrancais !== props.settingModal.titleFrancais || data.titleAnglais !== props.settingModal.titleAnglais) {
        httpClient.current?.put("/video_type", data).then(response => {
          props.toggle(null);
          toast.success(props.t("message_toastr_update"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
          props.handleGet();
        });
      } else {
        props.toggle(null);
      }
    }
  };

  const updateThematic = (data: ThematicDto) => {
    if (selectedSupport) {
      const formData = new FormData();
      formData.append("file", selectedSupport);
      httpClient.current
        ?.post(`/thematic/files?path=${path}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          data.pathImage = response.data;
          data.thematicId = props.settingModal.thematicId;
          httpClient.current?.put("/thematic", data).then(response => {
            props.toggle(null);
            toast.success(props.t("message_toastr_update"), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            props.handleGet();
          });
        });
    } else {
      data.thematicId = props.settingModal.thematicId;
      data.pathImage = props.settingModal.pathImage;
      data.urlImage = props.settingModal.urlImage;
      if (data.titleFrancais !== props.settingModal.titleFrancais || data.titleAnglais !== props.settingModal.titleAnglais) {
        httpClient.current?.put("/thematic", data).then(response => {
          props.toggle(null);
          toast.success(props.t("message_toastr_update"), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
          props.handleGet();
        });
      } else {
        props.toggle(null);
      }
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)} className="card m-b-0">
        <CardBody>
          <Row>
            <FormGroup className="col-md-12">
              <Label id="francais" className="form-label">
                {props.t("param_form.label_title_fr")}*
              </Label>
              <input {...register("titleFrancais", { required: true })} maxLength={100} className="form-control" type="text" placeholder={String(props.t("param_form.label_title_fr"))} />
            </FormGroup>
            <FormGroup className="col-md-12">
              <Label id="anglais" className="form-label">
                {props.t("param_form.label_title_en")}*
              </Label>
              <input {...register("titleAnglais", { required: true })} required maxLength={100} className="form-control" type="text" placeholder={String(props.t("param_form.label_title_en"))} />
            </FormGroup>
            <FormGroup className={styles["formGroup"] + " col-md-12"}>
              <Row>
                <Col xl="12" sm="12" md={{ size: 12, offset: 0 }}>
                  <Label id="upload">{props.t("param_form.label_representative_image")}*</Label>
                  {isShowDropZone &&
                    (!selectedSupport ? (
                      <Dropzone
                        key="in"
                        onChangeStatus={handleChangeStatus}
                        maxFiles={1}
                        accept={"image/*"}
                        multiple={false}
                        canCancel={true}
                        inputContent={
                          <div key="5">
                            <span className={styles["label-dropzone"] + " bold"}>
                              <i className="fa fa-plus"></i> {props.t("param_form.label_choose_image")}
                            </span>
                            <div className={styles["label-drop"]}>{props.t("param_form.label_drag_and_drop_here")}</div>
                          </div>
                        }
                        styles={{
                          dropzone: { width: "100%", height: 100, background: "#efefefbf", border: "none !important" },
                          dropzoneActive: { border: "none !important" },
                        }}
                      />
                    ) : (
                      <div className={styles["formGroup"] + " text-center"}>
                        <div className="uploadPictureP">
                          <div onClick={() => setSelectedSupport(null)} className={styles["deleteImageVideo"]}>
                            X
                          </div>
                          {selectedSupport.previewUrl}
                          <img className={styles["defaultImage"]} src={urlImage} alt="" />
                        </div>
                      </div>
                    ))}
                </Col>

                {!isShowDropZone && (
                  <div className={styles["formGroup"] + " text-center"}>
                    <div className="uploadPictureP">
                      <div
                        onClick={() => {
                          setIsShowDropZone(!isShowDropZone);
                          setSelectedSupport(null);
                        }}
                        className={styles["deleteImageVideo"]}
                      >
                        X
                      </div>
                      <img className={styles["defaultImage"]} src={props.settingModal?.urlImage + "/preview"} alt="" />
                    </div>
                  </div>
                )}
              </Row>
            </FormGroup>
          </Row>
          <div className="text-right">
            {props.settingModal?.urlImage ? (
              <ButtonComponent disable={false} buttonType="submit" buttonText={String(props.t("button_submit"))} save={true} />
            ) : (
              <ButtonComponent disable={!isValid || !selectedSupport} buttonType={"submit"} buttonText={String(props.t("button_submit"))} save={true} />
            )}

            <ButtonComponent onClick={() => props.toggle(null)} disable={false} buttonType={"button"} buttonText={String(props.t("button_cancel"))} save={false} />
          </div>
        </CardBody>
      </Form>
    </>
  );
};

export default translate(AddSetting);
